import { useEffect, useRef } from 'react';
export const initialDataMiddleware = useSWRNext => (key, fetcher, config) => {
  const hasMounted = useRef(false);
  const fallbackConfig = {
    ...config,
    fallbackData: hasMounted.current ? undefined : config.fallbackData,
    revalidateOnMount: config.revalidateOnMount ?? !config.fallbackData
  };
  const swr = useSWRNext(key, fetcher, fallbackConfig);
  const {
    mutate
  } = swr;
  useEffect(() => {
    if (config.fallbackData && !hasMounted.current) {
      // Populate the cache with the initial data
      mutate(config.fallbackData, false);
    }
  }, [mutate, config.fallbackData, key]);
  useEffect(() => {
    hasMounted.current = true;
    return () => {
      hasMounted.current = false;
    };
  }, []);
  return swr;
};
//# sourceMappingURL=initialDataMiddleware.js.map